import Vue from 'vue'
import App from './App.vue'
import VueGtag from 'vue-gtag'
import { BootstrapVue } from 'bootstrap-vue'
import i18n from './i18n'
import VueMoment from 'vue-moment'
import VueAxios from 'vue-axios'
import VueCurrencyFilter from 'vue-currency-filter'
import VeeValidate from 'vee-validate'
import VueNotification from 'vue-notification'
import router from './router'
import * as filters from './filters'
import './assets/scss/main.scss'
import store from './store'
import request from './utils/request'
import freshdesk from './utils/freshdesk'
import events from '@/utils/events'
import '@/components/global'
import mixpanel from '@/plugins/mixpanel'
import './mixins'
import VueTour from 'vue-tour'
import './plugins/sentry'

VeeValidate.Validator.localize({
  en: require('./i18n/en-IN').default
})
require('vue-tour/dist/vue-tour.css')
Vue.use(VeeValidate, {
  fieldsBagName: 'veeFields',
  classNames: 'v-error'
})

Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key])
})
Vue.use(
  VueGtag,
  {
    config: { id: process.env.VUE_APP_SCF_PORTAL_GA }
  },
  router
)

Vue.use(BootstrapVue)
Vue.use(VueAxios, request)
Vue.use(VueMoment)
Vue.use(VueNotification)
Vue.router = router
Vue.use(VueCurrencyFilter, {
  symbol: '$',
  thousandsSeparator: ',',
  fractionCount: 2,
  fractionSeparator: '.',
  symbolPosition: 'front',
  symbolSpacing: false
})
Vue.config.productionTip = false

Vue.use(mixpanel, {
  token: process.env.VUE_APP_SCF_MIXPANEL_TOKEN || 'dummy-token' // doesn't break the product
})
Vue.use(VueTour)
Vue.use(freshdesk)
Vue.use(events)

export const invoiceBus = new Vue()

new Vue({
  render: (h) => h(App),
  router,
  i18n,
  store
}).$mount('#app')
